<template>
  <div class="row">
    <div class="col">
      <div class="logo-container">
        <router-link to="/"><Logo class="logo"/></router-link>
      </div>
      <div class="content">
        <p>
          <MenuLink to="/about" text="Forty One Ravens" /> is grounded in
          elements that are deeply meaningful to me.
        </p>
        <p>
          The initials F.O.R. come from the names of the three children my wife
          Hermine and I have been blessed with: Felix, Ollie and Romy. The use
          of their initials reflects my desire to honor their role in my
          <MenuLink to="/professional-life" text="professional life" />.
        </p>
        <p>
          I want to be a role model for them and that has helped me to solely
          focus on working with people,
          <MenuLink to="/companies" text="companies" /> and causes that I am
          proud to associate with. That clarity is empowering and has liberated
          me to say no to investments and opportunities that would limit my time
          with them. With family at the center, I am committed to creating and
          maintaining deep, personal relationships in all the spheres of my
          life.
        </p>
        <p>
          41 is within striking distance of 42, ‘the answer to the ultimate
          question,’ serving as a playful reminder that while we may find
          moments of deep <MenuLink to="/insight" text="insight" /> we will
          never achieve all of the clarity we seek: it is the journey rather
          than the destination that makes life so interesting.
        </p>
        <p>
          Odin’s ravens reflect the balance I strike between data-driven
          approaches and a reliance on my intuition when solving problems. When
          dealing with complex systems such as people, businesses and markets
          the best judgments are informed by both analysis and instinct.
        </p>
        <p>
          Yet, 41 will never be 42 — there is a hint of the divine in the
          realization that even armed with our ravens we can only approximate
          the ‘right’ answers to life’s most meaningful questions. Ultimately
          the name is a reminder of how critical it is to retain appropriate
          humility in our approach to life even in the face of material success.
        </p>

        <ContentFooter />
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./Logo";
import MenuLink from "./MenuLink";
import ContentFooter from "./ContentFooter";

export default {
  name: "Home",
  components: {
    Logo,
    MenuLink,
    ContentFooter
  },
  data() {
    return {
      msg: ""
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Home.vue